/* eslint-disable react/prop-types */
import {
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { useEffect } from 'react';

const useStyles = makeStyles({
  title: {
    fontWeight: 'bold',
    marginBottom: '1em',
  },
  tableCell: {
    fontWeight: 'bold',
  },
});

const ClientTableReport = ({ leads }) => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.title}>Clientes</Typography>

      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell}>Cliente</TableCell>
              <TableCell className={classes.tableCell}>Corretor</TableCell>
              <TableCell className={classes.tableCell}>Motivo</TableCell>
              <TableCell className={classes.tableCell}>Canal</TableCell>
              <TableCell className={classes.tableCell}>Concessionária</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {leads?.map((lead) => (
              <TableRow>
                <TableCell>{lead?.client?.name}</TableCell>
                <TableCell>{lead?.broker?.name}</TableCell>
                <TableCell>{lead?.value}</TableCell>
                <TableCell>{lead?.channel?.name}</TableCell>
                <TableCell>{lead?.partner?.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ClientTableReport;
